import type { OrderDto } from '../../dto/order';
import { resolveOrderDeliveryAddress } from '../../utils/orderDeliveryAddress';

/**
 * Display mirror of the backend WZ recipient rule
 * (`backend/src/services/wzDocumentWorkflowPolicy.js`, decision
 * 2026-09-24-wz-adres-dostawy): the buyer comes from the customer card, the
 * delivery address defaults to the order's „Adres dostawy”, then to the
 * customer address. The backend re-resolves the snapshot on create, so this
 * only decides what the form shows.
 */
export interface WZCreateDeliveryDefaults {
  customerAddress: string;
  customerAddressMissing: boolean;
  deliveryAddress: string;
  /** Show the editable delivery input (it differs, or there is no customer address). */
  showDeliveryInput: boolean;
}

export function resolveWZCreateDeliveryDefaults(
  order: Pick<OrderDto, 'customer' | 'deliveryLocation'>,
): WZCreateDeliveryDefaults {
  const customerAddress = (order.customer?.address || '').trim();
  const deliveryAddress = resolveOrderDeliveryAddress(order);
  const customerAddressMissing = customerAddress === '';
  return {
    customerAddress,
    customerAddressMissing,
    deliveryAddress,
    showDeliveryInput: customerAddressMissing || deliveryAddress !== customerAddress,
  };
}

/** Link that opens the customer card straight in edit mode. */
export function buildCustomerCardEditPath(customerId: string): string {
  return `/app/customers/${encodeURIComponent(customerId)}?edit=1`;
}
